<template>
  <div>
    <PageBanner />
    <div class="relative">
      <NavBar class="z-20" />
      <div class="overflow-hidden">
        <slot />
      </div>
    </div>
    <NewsletterSignupModal />
    <div>
      <SvgMaskBlob />
      <SvgMaskScribble />
    </div>
  </div>
</template>
